import {addRUTDots} from '@/services/RUTFormatter'
export default {
    data: function(){
        return {
            mixRUTInputValue: '',
            mixRUTInputMask: '#.###.###-n',
        }
    },
    methods: {
        mixRUTInputHandler(input) {
            let lgt = input.length
            let lastChar = input.substr(lgt - 1)
            if (lgt < 8) {
                this.mixRUTInputMask = '#.###.###-n'
            } else if (lgt == 8 && !isNaN(lastChar)) {
                this.mixRUTInputMask = '#.###.###-#n'
            } else if (lgt == 8 && isNaN(lastChar)) {
                this.mixRUTInputMask = '#.###.###-n'
            } else if (lgt == 9) {
                this.mixRUTInputMask = '##.###.###-n'
            }
        },
        mixRUTInputHandlerAuto() {
            let lgt = this.rutInputValue.length
            let lastChar = this.rutInputValue.substr(lgt - 1)
            if (lgt < 8) {
                this.rutInputMask = '#.###.###-n'
            } else if (lgt == 8 && !isNaN(lastChar)) {
                this.rutInputMask = '#.###.###-#n'
            } else if (lgt == 8 && isNaN(lastChar)) {
                this.rutInputMask = '#.###.###-n'
            } else if (lgt == 9) {
                this.rutInputMask = '##.###.###-n'
            }
        },
        mixValidateRUT: function(rutCompleto) {
            try {
                if (rutCompleto.indexOf('-') == -1) {
                    rutCompleto = this.mixRUTFormatter(rutCompleto)
                }
                rutCompleto = rutCompleto.replace('‐', '-')
                if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto))
                    return false

                var tmp = rutCompleto.split('-')
                var digv = tmp[1]
                var rut = tmp[0]

                if (digv == 'K') digv = 'k'
                return this.mixDV(rut) == digv
            } catch (err) {
                return false
            }
        },
        mixDV: function(T) {
            var M = 0,
                S = 1
            for (; T; T = Math.floor(T / 10))
                S = (S + (T % 10) * (9 - (M++ % 6))) % 11
            return S ? S - 1 : 'k'
        },
        mixRUTFormatter(rut) {
            let lgt = rut.length
            let dv = rut.substr(lgt - 1)
            let rutSinDV = rut.substr(0, lgt - 1)
            return rutSinDV + '-' + dv
        },
        mixRUTRemoveHyphen(rut) {
            const arr = rut.split('-')
            return '' + arr[0] + arr[1]
        },
    },
    computed: {
        mixRUTRules: function() {
            let validaRut = this.mixValidateRUT
            return {
                validRUT: function(value) {
                    return validaRut(value) ? true : 'Rut no es válido'
                },
            }
        },
    },
    filters: {
        mixRUTFilter: function(val){
            return addRUTDots(val)
        }
    }
}

/*
 
 Ejemplo de uso del handler de input para rut:
 
 v-text-field(label="RUT" placeholder=" " :mask="rutInputMask" v-model="rutInputValue" @input="rutHandler()")
 
 */
